export const RUN_ACTIVE_STATUSES = ['running', 'scheduled', 'paused']

export const isRunFinished = (status: string): boolean => !RUN_ACTIVE_STATUSES.includes(status)

const RUN_STATUS_LABELS: Record<string, string> = {
  succeeded: 'success',
  paused: 'Waiting for input',
  'partial-succeeded': 'Partially succeeded',
}

export const runStatusLabel = (status: string): string => RUN_STATUS_LABELS[status] ?? status
